<script setup>

import RequestItem from "./RequestItem.vue";
import Dialog from "primevue/dialog";
import {computed, ref} from "vue";
import {usePage} from "@inertiajs/vue3";
const props = defineProps({
    styles: String,
    showAll: Boolean,
    pendingChangeRequest: Array
})
const visibleAll = ref(false);
const requests = computed(() => props.pendingChangeRequest ?? [])
</script>

<template>
    <div class="max-md:col-span-3 col-span-2 xl:col-span-5 flex flex-col md:border h-full dark:border-neutral-700 md:rounded-xl md:dark:bg-neutral-900 md:bg-white md:shadow max-md:-mx-3" :style="styles">
        <div class="max-md:hidden flex gap-2 items-center pb-3 justify-between border-b dark:border-neutral-700 pt-4 p-5">
            <p class="text-lg text-gray-800 dark:text-gray-200">{{ $t('dashboard.requests_title') }}</p>
            <p v-if="requests.length && !showAll" class="underline text-sm cursor-pointer underline-offset-4 transition-all hover:opacity-70"
               @click="visibleAll = true">{{ $t('common.show_all') }} ({{ requests.length }})</p>
        </div>
        <div v-if="requests.length" class="grow p-5 overflow-y-scroll ab max-md:pb-20">
            <transition-group name="list">
                <template v-for="(request, i) in requests" :key="request.id">
                    <request-item v-if="i < 3 || showAll" :request="request"></request-item>
                </template>
                <template v-if="requests.length > 3 && !showAll">
                    <div class="flex justify-center">
                        <p class="text-sm border-gray-400 dark:border-neutral-700 rounded-lg text-gray-600 dark:text-white pb-1 pt-1.5 px-4 border hover:shadow-lg cursor-pointer transition-all"
                           @click="visibleAll = true">{{ $t('dashboard.more_requests', { count: requests.length - 3 }) }}</p>
                    </div>
                </template>
            </transition-group>
        </div>
        <div v-else class="grow">
            <div class="flex justify-center rounded-2xl flex-col items-center text-center h-full gap-3 -mt-4">
                <i class="pi pi-check-circle bg-gray-200 dark:bg-gray-800 p-4 rounded-xl" style="font-size: 2rem"></i>
                <p class="font-bold">{{ $t('dashboard.requests_all_ok') }}</p>
                <p class="text-gray-700 text-sm dark:text-gray-300 max-w-[300px]">{{ $t('dashboard.requests_empty_desc') }}</p>
            </div>
        </div>
    </div>
    <Dialog v-model:visible="visibleAll" modal :header="$t('dashboard.requests_title')">
        <div class="border overflow-y-scroll p-4 bg-gray-50 dark:bg-gray-800 dark:border-neutral-700">

            <transition-group name="list">
                <template v-for="(request, i) in requests" :key="request.id">
                    <request-item :request="request"></request-item>
                </template>
            </transition-group>
        </div>
    </Dialog>
</template>

<style scoped lang="scss">

</style>
